import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ApplicationFilters = ({ 
  filters, 
  onFilterChange, 
  onReset,
  dealerships 
}) => {
  const statusOptions = [
    { value: 'all', label: 'Alle Status' },
    { value: 'unbestätigt', label: 'Unbestätigt' },
    { value: 'bestätigt', label: 'Bestätigt' },
    { value: 'processing', label: 'Beantragt' },
    { value: 'approved', label: 'Genehmigt' },
    { value: 'rejected', label: 'Abgelehnt' },
    { value: 'redeemed', label: 'Eingelöst' }
  ];

  const dealershipOptions = [
    { value: 'all', label: 'Alle Autohäuser' },
    ...dealerships?.map(d => ({ value: d?.id, label: d?.name }))
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          Filter
        </h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          Zurücksetzen
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Partner"
          options={dealershipOptions}
          value={filters?.dealership}
          onChange={(value) => onFilterChange('dealership', value)}
          searchable
        />

        <Input
          label="Von Datum"
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          label="Bis Datum"
          type="date"
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />
      </div>
      <div className="pt-4 border-t border-border">
        <Input
          type="search"
          placeholder="Suche nach Kunde, E-Mail, FIN, Kennzeichen..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default ApplicationFilters;